
import { mapGetters, mapState, mapMutations } from "vuex";
import orderPerHour from "~/assets/images/insights/order-per-hour.svg";

export default {
  data: () => ({ orderPerHour, selectedChannels: [] }),
  mounted() {
    this.selectAllChannels();
  },
  computed: {
    ...mapGetters("report", ["getChannels"])
  },
  watch: {
    getChannels(val) {
      this.selectAllChannels();
    }
  },
  methods: {
    selectAllChannels() {
      this.selectedChannels = JSON.parse(JSON.stringify(this.getChannels));
    }
  }
};
